import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // For page navigation
import './Search.css';

function Search() {
  const data = [
    'CampusBoard',
    'Academic Calendar',
    'Student ID',
    'Library',
    'Campus Map',
    'PeopleSoft',
    'Health Services',
    'Tech Help',
    'Campus Life'
  ];

  const [query, setQuery] = useState(''); // Store search query
  const navigate = useNavigate(); // Use navigate to redirect

  // Handle the search when the user hits Enter
  const handleSearch = (e) => {
    if (e.key === 'Enter') {
      // Check if the query matches one of the available options
      const result = data.find((item) => item.toLowerCase() === query.toLowerCase());
      if (result) {
        // If match found, navigate to the corresponding page
        navigate(`/${result.toLowerCase().replace(/\s+/g, '-')}`);
      }
      setQuery(''); // Clear the search input after search
    }
  };

  return (
    <div className="search-container">
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)} // Update query on input change
        onKeyDown={handleSearch} // Trigger search on Enter key press
        placeholder="Search..."
        className="search-input"
      />
    </div>
  );
}

export default Search;
